import FileSaver from 'file-saver'
import XLSX from 'XLSX'
import Blob from 'blob'
import host from '../config'

/**
 * Created by SJ on 11/29/16.
 */
// const host = 'http://test.uhomecp.com'
/** 11服务器 **/
// const hostImg = 'http://192.168.1.11:8082'
// const hostPrime = 'http://192.168.1.11:10080'

/** 71服务器 **/
// const hostImg = 'http://120.24.82.71:8082'
// const hostPrime = 'http://120.24.82.71:10080'

/** 打包服务器 **/
// const hostImg = 'http://192.168.1.11:8082'
// const hostPrime = process.env.NODE_ENV === 'development' ? 'http://192.168.1.11:10080' : '' //  开发与生产环境切换
const hostImg = host.hostImg
const hostPrime = host.hostPrime
const Util = {
  paths: {
    readToken: hostPrime + '/user/readToken',
    getCurrentUserDataById: hostPrime + '/getCurrentUserDataById/',
    /*  获取图库文件目录列表  */
    listIcon: hostPrime + '/template-api/rest-api/v5/icon/libs/listIcon.json',
    /*  图库信息获取图片或文件夹列表相关接口 */
    listChildrenIcon: hostPrime + '/template-api/rest-api/v5/icon/libs/listChildrenIcon.json',
    imgUploadUrl: hostPrime + '/uhomecp-app/common/oneFileUpload.json',
    imgServerDoamin: hostImg,
    getProductSecurityInfo: hostPrime + '/getProductSecurityInfo/'
  }
}

/**
 * 根据table dom 生成json数据
 * @param table dom
 * @returns {*[]} [0]是array,[1]是标识某些多行或者多列的项
 */
function generateArray(table) {
  var out = []
  var rows = table.getElementsByTagName('tr')
  var ranges = []
  for (var R = 0; R < rows.length; ++R) {
    var outRow = []
    var row = rows[R]
    var columns = row.getElementsByTagName('td')
    if (!columns.length) columns = row.getElementsByTagName('th')
    for (var C = 0; C < columns.length; ++C) {
      var cell = columns[C]
      var colspan = cell.colSpan
      var rowspan = cell.rowSpan
      var cellValue = cell.innerText
      if (cellValue !== '' && cellValue === +cellValue) cellValue = +cellValue

      // Skip ranges
      ranges.forEach(function (range) {
        if (R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
          for (var i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null)
        }
      })

      // Handle Row Span
      if (rowspan || colspan) {
        rowspan = rowspan || 1
        colspan = colspan || 1
        ranges.push({
          s: {r: R, c: outRow.length}, e: {r: R + rowspan - 1, c: outRow.length + colspan - 1}
        })
      }

      // Handle Value
      outRow.push(cellValue !== '' ? cellValue : null)

      // Handle Colspan
      if (colspan) for (var k = 0; k < colspan - 1; ++k) outRow.push(null)
    }
    out.push(outRow)
  }
  return [out, ranges]
}

function datenum(v, date1904) {
  if (date1904) {
    v += 1462
  }
  var epoch = Date.parse(v)
  return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000)
}

function sheetFromArrayOfArrays(data, opts) {
  var ws = {}
  var range = {s: {c: 10000000, r: 10000000}, e: {c: 0, r: 0}}
  for (var R = 0; R !== data.length; ++R) {
    for (var C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) range.s.r = R
      if (range.s.c > C) range.s.c = C
      if (range.e.r < R) range.e.r = R
      if (range.e.c < C) range.e.c = C
      var cell = {
        v: data[R][C]
      }
      if (cell.v == null) continue
      var cellRef = XLSX.utils.encode_cell({c: C, r: R})

      if (typeof cell.v === 'number') cell.t = 'n'
      else if (typeof cell.v === 'boolean') cell.t = 'b'
      else if (cell.v instanceof Date) {
        cell.t = 'n'
        cell.z = XLSX.SSF._table[14]
        cell.v = datenum(cell.v)
      } else {
        cell.t = 's'
      }

      ws[cellRef] = cell
    }
  }
  if (range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range)
  return ws
}

function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook()
  this.SheetNames = []
  this.Sheets = {}
}

function s2ab(s) {
  if (typeof ArrayBuffer !== 'undefined') {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
    return buf
  } else {
    var buf2 = new Array(s.length)
    for (var j = 0; j !== s.length; ++j) buf2[j] = s.charCodeAt(i) & 0xFF
    return buf2
  }
}

/**
 * 根据table dom 生成 文件
 * @param tableDom
 * @param type
 * @param fn 生成的文件名
 */
export function table2Excel(tableDom, type, fn) {
  console.debug(tableDom)
  var oo = generateArray(tableDom)
  var ranges = oo[1]

  /* original data */
  var data = oo[0]
  var wsName = 'SheetJS'

  var wb = new Workbook()
  var ws = sheetFromArrayOfArrays(data)

  /* add ranges to worksheet */
  ws['!merges'] = ranges

  /* add worksheet to workbook */
  wb.SheetNames.push(wsName)
  wb.Sheets[wsName] = ws

  console.log(wb)
  var wbout = XLSX.write(wb, {bookType: type, bookSST: false, type: 'binary'})
  var fname = (fn || 'test') + '.' + type
  try {
    FileSaver.saveAs(new Blob([s2ab(wbout)], {type: 'application/octet-stream'}), fname)
  } catch (e) {
    console.log(e, wbout)
  }
  return wbout
}

export default Util



// WEBPACK FOOTER //
// ./src/utils/utils.js